<script setup lang="ts">
import type User from '@/classes/user_classes/user';
import { useDashboardNavStore } from '@/store';
import { computed } from 'vue';

const { user } = defineProps<{ user: User }>()
const dashboardNavStore = useDashboardNavStore()

const avatarSrc = computed(() => user.avatarURL)

function handleNavigateToUserProfile() {
  dashboardNavStore.setDashboardDialogContent('account')
  // TODO: implement being able to see other users profiles, for now just navigate to the current users profile
}

</script>
<template>
  <v-card ripple class="rounded-lg" flat color="background" max-width="80px" @click="handleNavigateToUserProfile">
    <v-card-text class="pa-2 d-flex justify-center w-100 align-center" >
      <v-card class="d-flex justify-center align-center" width="56px" height="56px" flat>
        <v-avatar size="50">
          <img v-if="avatarSrc" :src="avatarSrc" width="100%" height="auto" />
          <v-icon v-else icon="custom:avatar" size="100%" />
        </v-avatar>
      </v-card>
    </v-card-text>

    <v-card-text class="text-center pt-0 text-truncate">
      <v-tooltip v-if="user.displayName" :text="user.displayName" location="top" content-class="bg-pwt_platinum">
        <template v-slot:activator="{ props }">
          <span v-bind="props" class="text-caption text-truncate">
            {{ user.displayName }}
          </span>
        </template>
      </v-tooltip>
      <span class="text-caption text-truncate" v-else>
        {{ user.displayName }}
      </span>
    </v-card-text>
  </v-card>
</template>
